import { GrFormClose } from 'react-icons/gr';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

// import 

const HomeScreenPopup = (props) => {
    const { componentSetting } = useSelector(state => ({
        componentSetting: state.componentSettingListR.data
    }));

    const [custComplaint, setCustComplaint] = useState(false);
    const btnRefLogin = useRef();
    const navigate = useNavigate();

    const handleNotificationPopup = () => {
        props.messageRead();
        props.handlePopup();
    }

    const handelSubmitOK = (data) => {
        if (data?.notification_type == "withdraw" || data?.notification_type == "deposit" || data?.notification_type == "deposit_reject" || data?.notification_type == "referral_bonus_group") {
            props.handlePopup();
            props?.setNotification(true);
            props.messageRead();

        } else {
            props.handlePopup();
            props.messageRead();
        }
    }
    const popupMessage = props.data?.popup_message || '';
    const notificationType = props.data?.notification_type || '';

    const renderPopupMessage = () => {
        const coloredPopupMessage = notificationType == "referral_bonus_group" ? popupMessage : popupMessage.replace(
            /IDR|\b\d{1,3}(?:,\d{3})*\b/g,
            (match) => `<span style="color: #d47dff; font-weight: 700;">${match}</span>`
        );

        // const coloredPopupMessage = popupMessage.replace(
        //     /IDR|\b\d{1,3}(?:,\d{3})*\b/g,
        //     (match) => `<span style="color: #d47dff; font-weight: 700;">${match}</span>`
        // );
        return <p style={{ wordWrap: 'break-word' }} ref={containerRef} dangerouslySetInnerHTML={{ __html: props.t(coloredPopupMessage) }} />;
    };


    const containerRef = useRef(null);

    useEffect(() => {
        const handleClick = (event) => {
            if (event?.target?.classList.contains('referral_bonus_group')) {
                event.preventDefault();
                handelSubmitOK(props?.data);
            }
        };

        const container = containerRef?.current;
        if (container) {
            container.addEventListener('click', handleClick);
        }

        return () => {
            if (container) {
                container.removeEventListener('click', handleClick);
            }
        };
    }, [props?.data]);

    return (
        <div className={`popup-modal ${custComplaint ? 'customerComplaintsClass' : ''}`} id='popup-model-id'>
            <div className="modal-cus" ref={btnRefLogin}>
                <span className="close" onClick={() => handleNotificationPopup()} ><GrFormClose /></span>
                <div className='popup-box'>

                    {props?.data != undefined && props.data?.popup_status == false &&
                        <>
                            <h4 className="title">{props.t('information')}</h4>
                            {(popupMessage !== '' || notificationType !== '') && renderPopupMessage()}
                            <div className='text-center depo-okbtn'>
                                {props.data?.notification_type === "withdraw" || props.data?.notification_type === "deposit" || props.data?.notification_type === "deposit_reject" || props.data?.notification_type === "referral_bonus_group" ? (
                                    <button onClick={() => handelSubmitOK(props?.data)}>{props.t('read')}</button>
                                ) : (
                                    <button onClick={() => handelSubmitOK(props?.data)}>{props.t('okay')}</button>
                                )}
                            </div>
                        </>
                    }

                </div>
            </div>
        </div>
    )
}

HomeScreenPopup.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(HomeScreenPopup);